// extracted by mini-css-extract-plugin
export var filterIncDec = "_ck-0";
export var leftBorder = "_ck-1";
export var rightBorder = "_ck-2";
export var stringInput = "_ck-3";